<template>
  <div ref="printContent" class="print-container">
    <div class="print-content">
      <Watermark />
      <section
        dir="rtl"
        style="
          font-size: 18px;
          font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
          background-color: transparent;
        "
        class="font-modify m-5"
      >
        <h1
          class="text-center text-dark mb-2"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 10px;
          "
        >
          {{ $brand.nameArShort }}
        </h1>
        <h4
          class="text-center text-dark"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 10px;
          "
        >
          اقرار خطي بموافقة المريض<br />
          على اجراء التدخلات والفحوصات الطبية
        </h4>

        <div
          class="mx-2 text-dark mt-2"
          dir="rtl"
          style="
            font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            background-color: transparent;
            padding: 15px;
          "
        >
          <p
            style="
              background-color: transparent;
              line-height: 2;
              text-align: right;
              font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            "
          >
            اني المريض
            <span
              style="text-decoration: underline; text-decoration-style: dotted"
            >
              {{ patientSurgeryData.patient_card.patient.name }}
            </span>
            الموقع ادناه والراقد في {{ $brand.nameArFull }}، اطلعني الطبيب طبيعة
            مرضي وعلى طبيعة التدخلات الطبية كافة (العلاجية والجراحية) اللازمة
            لعلاجي من مرضي وبضمنها المخاطر والمضاعفات التي قد تنجم عن تلك
            التدخلات او الفحوصات واوافق على اجراء تلك الفحوصات والتدخلات كما
            اوافق على اجراء عملية
            <span
              v-if="surgeryName"
              style="text-decoration: underline; font-weight: bold"
            >
              {{ surgeryName }}
            </span>
            واعطائي التخدير من قبل طبيب التخدير
            <span v-if="anesthetistName" style="text-decoration: underline">
              {{ anesthetistName }}
            </span>
            <span v-else style="text-decoration: underline">-</span>
            وبالطريقة التي يرتأيها مناسبة لحالتي وكما اخول الطبيب الجراح
            <span v-if="surgeonName" style="text-decoration: underline">
              {{ surgeonName }}
            </span>
            <span v-else style="text-decoration: underline">-</span>
            طلب المساعدة او استشارة طبيب اخر عند الضرورة ويعتبر هذا اقرار شامل
            اوقعة بارادتي وبكامل حريتي وذلك بتاريخ. وفي حالة تعذر قيام المريض
            على التوقيع لكونه قاصراً او متخلفاً عقلياً او فاقد للوعي او في حالة
            طارئة لايمكنه التوقيع يقوم احد افراد اسرته بالتوقيع نيابة عنه (على
            ان يكون من اقارب من الدرجة الاولى). يستثنى من ذلك تعرض حياة المريض
            للخطر او الموت عند تأخر اجرائها فيجوز عندئذ اجراء ما تتطلبه حالة
            المريض دون تحقق الموافقة المذكورة استناداً لقانون الصحة العامة رقم
            89 لسنة 1981 الباب الرابع الفرع الاول المادة 91 الفقرة (ب). في حال
            حدوث اي نزاع بين الطرفين تكون وزارة الصحة هي المرجع في حل هذا النزاع
            استناداً الى قانون رقم (26 لسنة 2013 المادة 1-اولاً والمادة 5)
            واتنازل عن حقي بمطالبة المستشفى او اي من الكادر العامل فيها بمطالبة
            عشائرية او دينية نتيجة اي ضرر مادي او معنوي.
          </p>
          <div
            class="my-5 d-flex justify-content-between mx-4"
            style="background-color: transparent; padding: 10px"
          >
            <section>
              <p
                style="
                  font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                  background-color: transparent;
                "
              >
                المريض او ذويه
              </p>
            </section>
            <section>
              <p
                style="
                  font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                  background-color: transparent;
                "
              >
                مسؤول الردهة
              </p>
            </section>
          </div>
          <!-- <hr
            class="dotted mx-4 text-dark border-dark border-2"
            style="background-color: transparent"
          />
          <p
            style="
              background-color: transparent;
              line-height: 2;
              text-align: right;
              font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
            "
          >
            اني المريض
            <span style="text-decoration: underline">
              {{ patientSurgeryData.patient_card.patient.name }}</span
            >
            اصر على الخروج من المستشفى رغم نصح الاطباء وكادر المستشفى وبذلهم كل
            المحاولات لاقناعي بالبقاء في المستشفى وحسب ما تقتضيه حالتي الصحية
            اخلي المسؤولية الاطباء والمستشفى من المضاعافات الناجمة عن خروجي من
            المستشفى وذلك بتاريخ (تعليمات وزارة الصحة كتاب رقم 10700 في
            2008/8/17).
          </p>
          <div
            class="my-5 d-flex justify-content-between mx-4"
            style="background-color: transparent; padding: 10px"
          >
            <section>
              <p
                style="
                  font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                  background-color: transparent;
                "
              >
                المريض او ذويه
              </p>
            </section>
            <section>
              <p
                style="
                  font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                  background-color: transparent;
                "
              >
                مسؤول الردهة
              </p>
            </section>
          </div> -->
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Watermark from "@/components/common/Watermark.vue";

export default {
  name: "AgreementPrint",
  components: {
    Watermark,
  },
  props: {
    patientSurgeryData: {
      type: Object,
      required: true,
    },
    surgeryName: {
      type: String,
      default: "",
    },
  },
  computed: {
    surgeonName() {
      if (
        this.patientSurgeryData.doctors_prices &&
        this.patientSurgeryData.doctors_prices.items &&
        Array.isArray(this.patientSurgeryData.doctors_prices.items)
      ) {
        const surgeon = this.patientSurgeryData.doctors_prices.items.find(
          (item) => item.type === "surgeon" && item.doctor
        );
        return surgeon ? surgeon.doctor.name : null;
      }
      return null;
    },
    anesthetistName() {
      if (
        this.patientSurgeryData.doctors_prices &&
        this.patientSurgeryData.doctors_prices.items &&
        Array.isArray(this.patientSurgeryData.doctors_prices.items)
      ) {
        const anesthetist = this.patientSurgeryData.doctors_prices.items.find(
          (item) => item.type === "anesthetist" && item.doctor
        );
        return anesthetist ? anesthetist.doctor.name : null;
      }
      return null;
    },
  },
  methods: {
    async print(surgeryName = "") {
      console.log(
        JSON.stringify(this.patientSurgeryData),
        "this.patientSurgeryData"
      );
      // Use provided surgeryName or prop
      const finalSurgeryName = surgeryName || this.surgeryName;
      const printWindow = window.open("", "_blank");
      const { printContent } = this.$refs;

      // Get watermark image source
      const watermarkImg = printContent.querySelector(".watermark-image");
      const watermarkSrc = watermarkImg ? watermarkImg.src : "";

      // Clone the content and update image sources
      const contentClone = printContent.cloneNode(true);
      const watermarkClone = contentClone.querySelector(".watermark-image");
      if (watermarkClone && watermarkSrc) {
        watermarkClone.src = watermarkSrc;
      }

      // Update surgery name in cloned content
      if (finalSurgeryName) {
        // Find the surgery name span (the one with font-weight: bold)
        const allSpans = contentClone.querySelectorAll("span");
        const surgeryNameSpan = Array.from(allSpans).find((span) => {
          const style = span.getAttribute("style") || "";
          return (
            style.includes("font-weight: bold") ||
            style.includes("font-weight:bold")
          );
        });
        if (surgeryNameSpan) {
          surgeryNameSpan.textContent = finalSurgeryName;
        } else {
          // If span doesn't exist, find the text and insert the surgery name
          const htmlContent = contentClone.innerHTML;
          const updatedContent = htmlContent.replace(
            /اوافق على اجراء عملية\s*<\/span>/,
            `اوافق على اجراء عملية <span style="text-decoration: underline; font-weight: bold">${finalSurgeryName}</span></span>`
          );
          contentClone.innerHTML = updatedContent;
        }
      }

      printWindow.document.write(`
        <!DOCTYPE html>
        <html dir="rtl">
          <head>
            <title>Agreement</title>
            <style>
              @page {
                size: A4;
                margin: 20mm;
              }
              body {
                font-family: 'Arial', 'Tahoma', 'Segoe UI', sans-serif;
                margin: 0;
                padding: 0;
                direction: rtl;
                background-color: transparent;
              }
              .print-content {
                position: relative;
              }
              .print-content > section,
              .print-content > div:not(.watermark-wrapper) {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .print-content h1,
              .print-content h4 {
                position: relative;
                z-index: 10 !important;
                text-align: center !important;
                background-color: transparent !important;
              }
              .print-content p,
              .print-content span,
              .print-content div,
              .print-content hr,
              .print-content section {
                position: relative;
                z-index: 10 !important;
                background-color: transparent !important;
              }
              .watermark-wrapper {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 0 !important;
                pointer-events: none;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .watermark-image {
                opacity: 0.2;
                max-width: 400px;
                max-height: 400px;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            </style>
          </head>
          <body>
            ${contentClone.innerHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.print-container {
  display: none;
}

@media print {
  .print-container {
    display: block;
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .print-content {
    position: relative;
    z-index: 1;
  }

  .print-content > section,
  .print-content > div:not(.watermark-wrapper),
  .print-content > h1,
  .print-content > h4,
  .print-content > p {
    position: relative;
    z-index: 10 !important;
    background: transparent;
  }

  .font-modify {
    letter-spacing: normal !important;
  }

  @page {
    size: A4;
    margin: 20mm;
  }
}
</style>
